import { render, staticRenderFns } from "./RequirementsExtractionProgress.vue?vue&type=template&id=2eba3634&scoped=true"
import script from "./RequirementsExtractionProgress.vue?vue&type=script&lang=js"
export * from "./RequirementsExtractionProgress.vue?vue&type=script&lang=js"
import style0 from "./RequirementsExtractionProgress.vue?vue&type=style&index=0&id=2eba3634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba3634",
  null
  
)

export default component.exports